import React, { useEffect, useState } from 'react';
import { Tooltip, Modal, Alert } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useRecoilState, useRecoilValue } from 'recoil';
import * as Yup from 'yup';
import { Button, Col, FormDatePicker, FormInput, FormSelect, FormSubmitButton, FormTextArea, MasterDetailForm, Row } from '@digital/ui';
import { ISasPropostaOrdemCompra, ISasPropostaOrdemCompraDocs, naoNegociarEnvioNegociacaoMinutaContratual, negociarEnvioNegociacaoMinutaContratual, getComentariosNegociacaoMinuta, salvarComentarioNegociacaoMinuta } from '@app/api/sas/sasProposta';
import { reenviarNegociacaoMinutaContratual } from '@app/api/sas/ordemCompra';
import { downloadArquivo } from '@app/api/sas/sasDocumentoOrdemCompra';
import { ModalInclusaoMultAnexo, Space, UploadFile, Visibility } from '@app/components';
import { editandoState, modalAcoesIdState, reloadVendorListState, vendorListDocsState, dataLimiteEtapaState } from '../atoms';
import { isObjNotEmpty, vtObjToFormData } from '@app/helpers/objHelper';
import { EStatusGenerico } from '@app/enums/EStatusGenerico';
import ModalConfirmContentJustificativa from '@app/components/ModalConfirmContent/ModalConfirmContentJustificativa';
import ListMensagem from './ComentariosParecerTecnico/ListMensagem';

interface IProps {
    sasProposta: ISasPropostaOrdemCompra;
}

export const BotoesEnvioNegociacaoMinutaContratual = ({ sasProposta }: IProps) => {

    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const [modalAcoesId, setModalAcoesId] = useRecoilState(modalAcoesIdState);
    const dataLimiteEtapa = useRecoilValue(dataLimiteEtapaState);

    const [exibirModal, setExibirModal] = useState(false);
    const [exibirModalReenvio, setExibirModalReenvio] = useState(false);
    const [initialValues, setInitialValues] = useState<any>({} as any);
    const [editando, setEditando] = useRecoilState(editandoState);
    const [comentarios, setComentarios] = useState([]);
    const [textoComentario, setTextoComentario] = useState('');

    const vendorListDocs = useRecoilValue(vendorListDocsState);
    const [doc, setDoc] = useState<ISasPropostaOrdemCompraDocs>({} as ISasPropostaOrdemCompraDocs);

    const carregarComentarios = () => {
        getComentariosNegociacaoMinuta(sasProposta.id).then(setComentarios);
    };

    useEffect(() => {
        setInitialValues({
            statusEnvioNegociacaoMinutaContratual: sasProposta.statusEnvioNegociacaoMinutaContratual,
            proponente: sasProposta.sasFornecedorOcNome,
            dataEnvioMinutaPreenchida: sasProposta.dataStatusEnvioNegociacaoMinutaContratual,
            dataPrazoDevolutiva: sasProposta.dataPrazoDevolutivaEnvioNegociacaoMinutaContratual,
            observacoes: sasProposta.observacoesEnvioNegociacaoMinutaContratual,
            justificativa: sasProposta.justificativaEnvioNegociacaoMinutaContratual,
        });

        var doc = vendorListDocs.find(f => f.id == sasProposta.id);
        if (isObjNotEmpty(doc)) {
            setDoc(doc || {} as ISasPropostaOrdemCompraDocs);
        }

        if (exibirModalReenvio) {
            carregarComentarios();
        }
    }, [exibirModalReenvio]);

    const handleCancel = () => {
        setExibirModal(false);
    };

    const handleSubmit = (values: any) => {
        const form = vtObjToFormData(values);
        form.append('sasPropostaId', sasProposta.id);


        if (editando.sasPropostaId == sasProposta.id) {
            Modal.confirm({
                title: <>{editando.justificativa}</>,
                content: <ModalConfirmContentJustificativa
                    texto='É necessário informar a justificativa para a alteração.'
                    setJustificativa={e => {
                        form.set('justificativaEdicao', e);
                    }} />,
                okText: 'Confirmar',
                cancelText: 'Cancelar',
                onOk: async (e) => {
                    form.append('editando', 'true');
                    return new Promise<void>((resolve, reject) => {
                        negociarEnvioNegociacaoMinutaContratual(sasProposta.id, form)
                            .then((data: any) => {
                                if (data && data.valid) {
                                    setReloadVendorList(!reloadVendorList);
                                    handleCancel();
                                    return resolve();
                                } else {
                                    if (data.notifications && data.notifications.length > 0) {
                                        const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                                            return c.property == 'justificativaEdicao';
                                        });
                                        if (erroJustificativaEdicao >= 0) {
                                            return reject();
                                        }
                                    }
                                }
                            });
                    });
                },
                onCancel: () => { setModalAcoesId(''); }
            });
        } else {
            negociarEnvioNegociacaoMinutaContratual(sasProposta.id, form)
                .then((data: any) => {
                    if (data && data.valid) {
                        setReloadVendorList(!reloadVendorList);
                        handleCancel();
                        setModalAcoesId('');
                    }
                });
        }
    };


    const naoNegociar = async (idRecord: string, values: any): Promise<boolean> => {

        const form = vtObjToFormData(values);
        form.append('sasPropostaId', sasProposta.id);

        if (editando.sasPropostaId == idRecord) {
            Modal.confirm({
                title: <>{editando.justificativa}</>,
                content: <ModalConfirmContentJustificativa
                    texto='É necessário informar a justificativa para a alteração.'
                    setJustificativa={e => {
                        form.set('justificativaEdicao', e);
                    }} />,
                okText: 'Confirmar',
                cancelText: 'Cancelar',
                onOk: async (e) => {
                    form.append('editando', 'true');
                    return new Promise<boolean>((resolve, reject) => {
                        naoNegociarEnvioNegociacaoMinutaContratual(idRecord, form)
                            .then((data: any) => {
                                if (data && data.valid) {
                                    setReloadVendorList(!reloadVendorList);
                                    return resolve(true);
                                } else {
                                    if (data.notifications && data.notifications.length > 0) {
                                        const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                                            return c.property == 'justificativaEdicao';
                                        });
                                        if (erroJustificativaEdicao >= 0) {
                                            return reject(false);
                                        }
                                    }
                                }
                            });
                    });
                },
                onCancel: () => { setModalAcoesId(''); }
            });
        } else {
            await naoNegociarEnvioNegociacaoMinutaContratual(idRecord, form)
                .then((data: any) => {
                    if (data && data.valid) {
                        setReloadVendorList(!reloadVendorList);
                        return true;
                    }
                    return false;
                });
        }

        return true;
    };

    const handleReenvio = async (values: any) => {
        if (textoComentario.trim()) {
            const comentarioForm = new FormData();
            comentarioForm.append('sasPropostaId', sasProposta.id);
            comentarioForm.append('comentario', textoComentario);
            await salvarComentarioNegociacaoMinuta(comentarioForm);
            setTextoComentario('');
        }

        reenviarNegociacaoMinutaContratual(
            sasProposta.ordemCompraId,
            sasProposta.id,
            textoComentario,
            values.dataLimite,
            values.arquivo
        ).then((data: any) => {
            if (data && data.valid) {
                setReloadVendorList(!reloadVendorList);
                setExibirModalReenvio(false);
                setModalAcoesId('');
            }
        });
    };

    return (
        <Row>
        <Visibility visible={true}>
           
                <Row align='middle' justify='center'>
                    <Row align='middle' justify='center' style={{ display: 'flex'}}>

                        <Visibility visible={sasProposta.statusEnvioNegociacaoMinutaContratual !== EStatusGenerico.NAO_NEGOCIAR ||
                            editando.sasPropostaId === sasProposta.id}>
                            <Tooltip title="Enviar">
                                <Button icon='commons-ok' onClick={() => { setExibirModal(true); }} />
                            </Tooltip>
                        </Visibility>

                        <Visibility visible={sasProposta.statusEnvioNegociacaoMinutaContratual === EStatusGenerico.MINUTA_RECUSADA}>
                            <Space ml={4} />
                            <Tooltip title="Reenviar com ajustes">
                                <Button icon='commons-refresh' onClick={() => setExibirModalReenvio(true)} />
                            </Tooltip>
                            <Space mr={4} />
                        </Visibility>

                        <Visibility visible={sasProposta.statusEnvioNegociacaoMinutaContratual !== EStatusGenerico.MINUTA_VALIDADA ||
                            editando.sasPropostaId === sasProposta.id}>
                            <Space ml={4} />
                            <ModalInclusaoMultAnexo
                                buttonIcon="commons-cancel"
                                buttonTooltip='Não Enviar'
                                onSubmit={async (values) => {
                                    const data = await naoNegociar(sasProposta.id, values);
                                    setModalAcoesId('');
                                    return data;
                                }}
                                showUploadArquivos={false}
                                showJustificativa={true}
                                textButtonSave="Salvar"
                                initialValues={initialValues}
                                disabledFields={editando.sasPropostaId !== sasProposta.id &&
                                    sasProposta.statusEnvioNegociacaoMinutaContratual === EStatusGenerico.NAO_NEGOCIAR} />
                        </Visibility>
                    </Row>
                </Row>

            

            <Visibility visible={exibirModal}>

                <Modal
                    title="Negociar Minuta"
                    width="980px"
                    visible={exibirModal}
                    onCancel={handleCancel}
                    footer={null}
                >
                    <MasterDetailForm
                        key={`form_BotoesEnvioNegociacaoMinutaContratual_${sasProposta.id}`}
                        initialValues={initialValues}
                        actions={[
                            <Button title='fechar' type='link' onClick={() => handleCancel()} />,
                            <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />
                        ]}
                        validationSchema={Yup.object().shape({
                            arquivo: isObjNotEmpty(doc) && doc.anexoEnvioNegociacaoMinutaContratual ? Yup.mixed().notRequired() : Yup.mixed().required('É necessário anexar um arquivo.'),
                            dataEnvioMinutaPreenchida: Yup.string().required('O campo é obrigatório.'),
                            dataPrazoDevolutiva: Yup.string().required('O campo é obrigatório.'),
                        })}
                    >
                        <Row>
                            <FormSelect
                                label='Status'
                                name='statusEnvioNegociacaoMinutaContratual'
                                value={sasProposta.statusEnvioNegociacaoMinutaContratual
                                    ? sasProposta.statusEnvioNegociacaoMinutaContratual
                                    : EStatusGenerico.PENDENTE}
                                options={[
                                    { text: EStatusGenerico.PENDENTE, value: EStatusGenerico.PENDENTE },
                                    { text: EStatusGenerico.EM_NEGOCIACAO, value: EStatusGenerico.EM_NEGOCIACAO },
                                    { text: EStatusGenerico.MINUTA_VALIDADA, value: EStatusGenerico.MINUTA_VALIDADA },
                                    { text: EStatusGenerico.MINUTA_RECUSADA, value: EStatusGenerico.MINUTA_RECUSADA },
                                ]}
                                span={6}
                                disabled />

                            <FormInput
                                name="proponente"
                                label='Proponente'
                                value={sasProposta.sasFornecedorOcNome}
                                disabled
                                span={6} />

                            <FormDatePicker
                                label='Data do envio da Minuta preenchida'
                                name='dataEnvioMinutaPreenchida'
                                format='DD/MM/YYYY'
                                span={6} />

                            <FormDatePicker
                                label='Prazo para a Devolutiva'
                                name='dataPrazoDevolutiva'
                                format='DD/MM/YYYY'
                                span={6}
                                disabledDate={function(current) {
                                    if (!dataLimiteEtapa) return false;
                                    var limite = new Date(dataLimiteEtapa);
                                    limite.setHours(23, 59, 59, 999);
                                    return current && current.toDate() > limite;
                                }} />

                            <FormTextArea
                                label='Observações'
                                name='observacoes'
                                span={12} />
{/* 
                            <FormTextArea
                                label='Justificativa'
                                name='justificativa'
                                span={12} /> */}
                        </Row>
                        <Row>
                            <Col span={6}>
                                <br></br>
                                <UploadFile
                                    idDoComponente='arquivo-BotoesEnvioNegociacaoMinutaContratual'
                                    type='primary'
                                    hasFile={false}
                                    hasLabel={true}
                                    icon='ui-upload'
                                    span={6} />
                                {isObjNotEmpty(doc) && doc.anexoEnvioNegociacaoMinutaContratual && (
                                    <Button
                                        icon='ui-download'
                                        type='primary'
                                        onClick={() => downloadArquivo(doc.anexoEnvioNegociacaoMinutaContratual.id, doc.anexoEnvioNegociacaoMinutaContratual.nome)} />
                                )}
                            </Col>
                        </Row>
                    </MasterDetailForm>

                    
                </Modal>
            </Visibility>

            <Visibility visible={exibirModalReenvio}>
                <Modal
                    title="Reenviar Minuta com Ajustes"
                    width="680px"
                    visible={exibirModalReenvio}
                    onCancel={() => setExibirModalReenvio(false)}
                    footer={null}
                >
                    
                    
                        <MasterDetailForm
                            key={`form_ReenvioNegociacaoMinutaContratual_${sasProposta.id}`}
                            initialValues={{}}
                            actions={[
                                <Button title='fechar' type='link' onClick={() => setExibirModalReenvio(false)} />,
                                <FormSubmitButton title='Reenviar' type='primary' noIcon onClick={handleReenvio} />
                            ]}
                            validationSchema={Yup.object().shape({
                                arquivo: Yup.mixed().required('É necessário anexar a nova minuta.'),
                                dataLimite: Yup.string().nullable().required('Data limite é obrigatória'),
                            })}
                        >

                            
                            <Row style={{ alignItems: 'flex-end' }}>
                                <FormDatePicker
                                    label="Data Limite de Resposta"
                                    name="dataLimite"
                                    format="DD/MM/YYYY"
                                    span={4}
                                    disabledDate={function (current):any {
                                        if (!dataLimiteEtapa) return false;
                                        var limite = new Date(dataLimiteEtapa);
                                        limite.setHours(23, 59, 59, 999);
                                        return current && current.toDate() > limite;
                                    }}
                                />
                                <Col style={{ display: 'flex', gap: 8, alignItems: 'flex-end', paddingBottom: 4 }}>
                                    <UploadFile
                                        idDoComponente='arquivo-ReenvioNegociacaoMinutaContratual'
                                        nameFormData="arquivo"
                                        type='primary'
                                        hasFile={false}
                                        hasLabel={true}
                                        label='Reenviar Minuta'
                                        icon='ui-upload'
                                        span={6} />
                                    {isObjNotEmpty(doc) && doc.anexoEnvioNegociacaoMinutaContratual && (
                                        <Button
                                            icon='ui-download'
                                            type='primary'
                                            onClick={() => downloadArquivo(doc.anexoEnvioNegociacaoMinutaContratual.id, doc.anexoEnvioNegociacaoMinutaContratual.nome)}>Minuta recusada</Button>
                                    )}
                                </Col>
                            </Row>
                            <Row style={{marginBottom: 8}}>
                                <Col span={24}>
                                    <strong>Comunicação com o Fornecedor</strong>
                                    <Row style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid #f0f0f0', padding: 8, marginTop: 8,  }}>
                                        <ListMensagem mensagens={comentarios} />
                                    </Row>
                                    <TextArea
                                        value={textoComentario}
                                        onChange={e => setTextoComentario(e.target.value)}
                                        placeholder="Mensagem para o fornecedor"
                                        maxLength={150}
                                        autosize={{ minRows: 2, maxRows: 4 }}
                                        style={{ marginTop: 8 }}
                                    />
                                </Col>
                            </Row>
                        </MasterDetailForm>
                </Modal>
            </Visibility>
        </Visibility>
        </Row>
    );
};
